import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FirstAbout from './../block/FirstAbout'
import AboutOnPage from './../block/AboutOnPage'
import PodhodOnPage from './../block/PodhodOnPage'
import RecomendedNg from './../block/RecomendedNg'
import FeedbackNg from './../block/FeedbackNg'
import ShopsNg from './../block/ShopsNg'
import QwestionsNg from './../block/QwestionsNg'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, showInCart, favorite, changeFavorite, cart, in_cart_loading } = this.props

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <FirstAbout
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          <AboutOnPage />
          <PodhodOnPage />
          <RecomendedNg
            title={`НОВЫЕ ПОСТУПЛЕНИЯ`}
            text={`Посмотрите наши последние поступления дизайнерской одежды и подберите свой стиль`}
            showInCart={showInCart}
            in_cart_loading={in_cart_loading}
            favorite={favorite}
            changeFavorite={changeFavorite}
            cart={cart}
            link={page_data.new_link}
            variant={`new`}
            start={ajax_data?.new_products || { page: 1, paginator: [], products: [] }}
          />
          <FeedbackNg
            ajax_data={ajax_data}
          />
          <ShopsNg
            page_data={page_data}
            ajax_data={ajax_data}
          />
          <QwestionsNg
            ajax_data={ajax_data}
          />
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool
}